var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscordGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9167 2.83333C26.9167 2.83333 23.669 0.291833 19.8333 0L19.4877 0.691333C22.9557 1.53992 24.5466 2.75612 26.2083 4.25C23.3431 2.78729 20.514 1.41667 15.5833 1.41667C10.6526 1.41667 7.82354 2.78729 4.95833 4.25C6.62008 2.75612 8.51275 1.40604 11.679 0.691333L11.3333 0C7.30929 0.380375 4.25 2.83333 4.25 2.83333C4.25 2.83333 0.622625 8.09271 0 18.4167C3.65642 22.6334 9.20833 22.6667 9.20833 22.6667L10.3693 21.119C8.39871 20.434 6.17312 19.2107 4.25 17C6.54358 18.7354 10.0052 20.5417 15.5833 20.5417C21.1615 20.5417 24.6231 18.7354 26.9167 17C24.9935 19.2107 22.768 20.434 20.7974 21.119L21.9583 22.6667C21.9583 22.6667 27.5102 22.6334 31.1667 18.4167C30.544 8.09271 26.9167 2.83333 26.9167 2.83333ZM10.9792 15.5833C9.60996 15.5833 8.5 14.3147 8.5 12.75C8.5 11.1853 9.60996 9.91667 10.9792 9.91667C12.3484 9.91667 13.4583 11.1853 13.4583 12.75C13.4583 14.3147 12.3484 15.5833 10.9792 15.5833ZM20.1875 15.5833C18.8183 15.5833 17.7083 14.3147 17.7083 12.75C17.7083 11.1853 18.8183 9.91667 20.1875 9.91667C21.5567 9.91667 22.6667 11.1853 22.6667 12.75C22.6667 14.3147 21.5567 15.5833 20.1875 15.5833Z",
    fill: "#838383",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordGrey);
export default __webpack_public_path__ + "static/media/DiscordGrey.ae202a6ade86fbda386dfb8b98d31bcc.svg";
export { ForwardRef as ReactComponent };